import React, { useEffect } from 'react';
import { Button, Row, Col, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';

import { InputField } from 'src/components/form';
import { FormValue } from '../useForm';
import { DestinationModal } from 'src/components/common';
import Modal from 'src/components/custom/Modal';
import { SCREENS } from 'src/constants/screens';
import { useLocation } from 'react-router-dom';
import { checkChangeLanguage } from 'src/utils/helper';

type Props = {
  formInfo: UseFormReturn<FormValue, any>;
  accountInfo?: any;
  prevLang: string;
  lang: string;
};

const CustomerInfo: React.FC<Props> = ({
  formInfo,
  accountInfo,
  prevLang,
  lang,
}) => {
  const { control, setValue, getValues, clearErrors } = formInfo;
  const { t } = useTranslation();
  const location = useLocation();
  useEffect(() => {
    if (accountInfo?.rmOtokesaki && !getValues('destination')) {
      onChooseDestination(accountInfo);
    }
  }, [accountInfo]);

  const destinationInfo = {
    rmOtokesaki: {
      otokesakiCd: accountInfo?.otokesakiCd,
      otokesakiNm: accountInfo?.otokesakiNm,
      otodokesakiJusho: accountInfo?.otodokesakiJusho,
    },
  };

  useEffect(() => {
    // get default address if Change language
    if (checkChangeLanguage(prevLang, lang)) {
      getDefaultAddress();
    }
  }, [lang]);

  useEffect(() => {
    // get default address if click Quotation/Order Tab
    getDefaultAddress();
  }, [location?.search, accountInfo]);

  //get default address
  const getDefaultAddress = () => {
    if (accountInfo?.otokesakiCd) {
      onChooseDestination(destinationInfo);
    } else {
      setValue('destination', '');
      setValue('destinationItem', undefined);
      clearErrors('destination');
    }
  };

  const onChooseDestination = (destination) => {
    setValue('destination', getDestinationInputValue(destination));
    setValue('destinationItem', destination);
    clearErrors('destination');
  };

  const getDestinationInputValue = (destination) => {
    return `${destination?.rmOtokesaki?.otokesakiCd} ${destination?.rmOtokesaki?.otokesakiNm} ${destination?.rmOtokesaki?.otodokesakiJusho}`;
  };

  return (
    <React.Fragment>
      <Row className="delivery-address" align="middle">
        <Col className="delivery-address_label">
          <Typography.Title level={5} className="form_label_required">
            {t('pricing_page.user_destination_field')}
          </Typography.Title>
        </Col>
        <Col xs={7} sm={14} md={16} xl={8} className="user_destination">
          <InputField<FormValue>
            controller={{ control, name: 'destination' }}
            inputProps={{
              placeholder: t('pricing_page.user_destination_field'),
              minLength: 1,
              maxLength: 200,
              disabled: true,
            }}
            required
            className="user_destination_input custom_disabled_input"
          />
        </Col>
        <Col xs={4} sm={4} md={4} xl={4} className="user_destination_action">
          <Modal
            modalProps={{ width: 840 }}
            title={t('pricing_page.destination_modal.title')}
            content={({ onClose }) => (
              <DestinationModal
                screenId={SCREENS.R2001}
                onClose={onClose}
                onSelect={onChooseDestination}
              />
            )}
          >
            <Button
              type="primary"
              className="btn-custom"
              style={{ width: 114, marginLeft: 20 }}
            >
              {t('pricing_page.user_destination_button')}
            </Button>
          </Modal>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default CustomerInfo;
